import {
  FETCH_SPECIAL_OFFERS_CREATOR_REQUEST,
  FETCH_SPECIAL_OFFERS_CREATOR_SUCCESS,
  FETCH_SPECIAL_OFFERS_CREATOR_FAILURE,
  UPDATE_SELECTED_PRODUCTS
} from '../../actionTypes/specialOffersCreatorActionTypes'

const fetchSpecialOffersCreatorRequest = (payload, baseUrl) => ({
  type: FETCH_SPECIAL_OFFERS_CREATOR_REQUEST,
  payload,
  baseUrl
})

const fetchSpecialOffersCreatorSuccess = payload => ({
  type: FETCH_SPECIAL_OFFERS_CREATOR_SUCCESS,
  payload
})

const fetchSpecialOffersCreatorFailure = payload => ({
  type: FETCH_SPECIAL_OFFERS_CREATOR_FAILURE,
  payload
})

const updateSelectedProducts = payload => ({
  type: UPDATE_SELECTED_PRODUCTS,
  payload
})

export {
  fetchSpecialOffersCreatorRequest,
  fetchSpecialOffersCreatorSuccess,
  fetchSpecialOffersCreatorFailure,
  updateSelectedProducts
}
